import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'lp2-ec-modal',
  templateUrl: './ec-modal.component.html',
  styleUrls: ['./ec-modal.component.scss'],
})
export class ECModalComponent implements OnInit {
  @ViewChild('player') player: ElementRef;
  @Input() title: string;
  @Output() loaded = new EventEmitter();
  loading = true;
  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {
    this.loaded.emit();
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/ec-modal/ec-modal.component.ts